import React from 'react';
import cn from 'classnames';
import { string, bool } from 'prop-types';

import styles from './styles.module.scss';

function LoadingSpinner({ classNames, isVisible = true }) {
  return (
    <i
      className={cn('icon-spinner', styles.faSpin, classNames, {
        [styles.visible]: isVisible,
        [styles.notVisible]: !isVisible
      })}
    />
  );
}

LoadingSpinner.propTypes = {
  classNames: string,
  isVisible: bool
};

export default LoadingSpinner;
